<template>
  <button @click="exportReferral" class="btn btn-primary mr-1">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop no-enforce-focus>
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <div class="text-center">
        <b-spinner></b-spinner>
      </div>
    </b-modal>
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';

export default {
  props: ['data', 'sum', "avg", "label"],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportReferral: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);
      if (this.sum) {
        let row = this.sum;
        row.label = this.$t('total');
        sheet.addRow(row);
      }
      if (this.avg) {
        let row = this.avg;
        row.label = this.$t('average');
        sheet.addRow(row);
      }
      this.data.forEach(item => {
          let row = item;
          row.label = this.label(item);
          row.total = item.total;
          row.success = item.success;
          sheet.addRow(row);
          this.downloadedCount += 1;
        });

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'referral-report.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      let colunms = [
        {header: '', key: 'label', width: 15},
        {header: this.$t('totalReferral'), key: 'total', width: 15},
        {header: this.$t('successReferral'), key: 'success', width: 15},
      ];
      sheet.columns = colunms;
    },
    close() {
      this.cancelRequest = true;
    }
  },
  i18n: {
    messages: {
      en: {
        totalReferral: "Total referral",
        successReferral: "Success referral"
      },
      vi: {
        totalReferral: "Số lượt giới thiệu",
        successReferral: "Giới thiệu thành công"
      }
    }
  }
}
</script>
